import { ArslActionSetColumns, ArsListingState } from "../interface";
import { datasetsFromColumns } from "./datasetsFromColumns";

/**
 * Replaces the current listing columns with a capped column set.
 *
 * @param state - Current ARS listing state
 * @param action - Set-columns action containing the replacement columns
 * @returns Updated ARS listing state with the new columns applied
 */
export const arsl_setColumns = <T>(
  state: ArsListingState<T>,
  action: ArslActionSetColumns<T>,
): ArsListingState<T> => ({
  ...state,
  changed: true,
  bodyData: {
    ...state.bodyData,
    arsListingColumns: action.columns.slice(0, 20),
  },
  datasets: datasetsFromColumns(action.columns),
});
